import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import SecMasterGrid from './SecMasterGrid';
import RatingsGrid from './RatingsGrid';
import RatingsInputs from './RatingsInputs';

export default function Dashboard({ userId }) {
  const [tab, setTab] = useState(0);
  const [ratingsVisited, setRatingsVisited] = useState(false);
  const [inputsVisited, setInputsVisited] = useState(false);
  const [inputRevision, setInputRevision] = useState(0);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Tabs
        value={tab}
        onChange={(_, value) => {
          setTab(value);
          if (value === 1) setRatingsVisited(true);
          if (value === 2) setInputsVisited(true);
        }}
        aria-label="SecMaster tabs"
      >
        <Tab label="SecMaster" id="secmaster-tab" aria-controls="secmaster-panel" />
        <Tab label="Ratings" id="ratings-tab" aria-controls="ratings-panel" />
        <Tab label="Input" id="input-tab" aria-controls="input-panel" />
      </Tabs>
      <Box
        role="tabpanel"
        id="secmaster-panel"
        aria-labelledby="secmaster-tab"
        hidden={tab !== 0}
        sx={{ flex: 1, minHeight: 0 }}
      >
        <SecMasterGrid userId={userId} />
      </Box>
      <Box
        role="tabpanel"
        id="ratings-panel"
        aria-labelledby="ratings-tab"
        hidden={tab !== 1}
        sx={{ flex: 1, minHeight: 0 }}
      >
        {ratingsVisited && <RatingsGrid inputRevision={inputRevision} />}
      </Box>
      <Box
        role="tabpanel"
        id="input-panel"
        aria-labelledby="input-tab"
        hidden={tab !== 2}
        sx={{ flex: 1, minHeight: 0 }}
      >
        {inputsVisited && <RatingsInputs onSaved={() => setInputRevision((value) => value + 1)} />}
      </Box>
    </Box>
  );
}
